// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const MaintenancePlanReport = t.struct({
    actualHours: t.maybe(t.Number),
    completionDate: t.maybe(t.Number),
    contractNumber: t.maybe(t.String),
    customerName: t.maybe(t.String),
    customerNumber: t.maybe(t.String),
    dealerCity: t.maybe(t.String),
    dealerName: t.maybe(t.String),
    hoursLimit: t.maybe(t.Number),
    intervalBeginDate: t.maybe(t.Number),
    intervalEndDate: t.maybe(t.Number),
    intervalTypeDescription: t.maybe(t.String),
    model: t.maybe(t.String),
    pin: t.maybe(t.String),
    planDescription: t.maybe(t.String),
    planEndDate: t.maybe(t.Number),
    planName: t.maybe(t.String),
    planStartDate: t.maybe(t.Number),
    responsibleDealer: t.maybe(t.String),
    serviceIntervalNumber: t.maybe(t.String),
    serviceIntervalStatus: t.maybe(t.String),
    serviceIntervalType: t.maybe(t.String),
    statusDescription: t.maybe(t.String)
}, {
    name: 'MaintenancePlanReport',
    strict: true
});

export const getDefaultState = () => new MaintenancePlanReport({});

export default MaintenancePlanReport;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/maintenance-plan-report.js